export enum OnClickAction {
  IdentifyToTables = 'IdentifyToTables',
  Disabled = 'Disabled',
  Popup = 'Popup',
  ToExport = 'ToExport'
}
